import { render, staticRenderFns } from "./XTableRow.vue?vue&type=template&id=4bc62f9b&scoped=true&"
import script from "./XTableRow.vue?vue&type=script&lang=js&"
export * from "./XTableRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc62f9b",
  null
  
)

export default component.exports